import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import { Link } from '~/routes';
import getOr from '~/util/getOr';
import replace from 'lodash/replace';

import css from '~/components/AuthorBanner/AuthorBanner.scss';

const getHeadshot = author => getOr(author, 'headshot.url', '/static/vectors/default_avatar.svg');

class AuthorBanner extends React.PureComponent {
  render() {
    const { author, rivers } = this.props;
    const twitterUsername = replace(author.twitter_handle, '@', '');
    const twitterUrl = `https://twitter.com/${twitterUsername}`;

    return (
      <div className={css.authorBanner}>
        <div className={css.headshot}>
          <img src={getHeadshot(author)} alt="" />
        </div>
        <div className={css.authorInfo}>
          <div className={css.name}>{author.name}</div>
          <div className={css.bio}>{author.bio}</div>
          <div className={css.socialAndWork}>
            {author.twitter_handle &&
              author.twitter_handle.trim !== '' && (
                <div className={css.social}>
                  <span className={css.label}>Twitter:</span>
                  <a href={twitterUrl} className={css.socialHandle}>
                    {author.twitter_handle}
                  </a>
                </div>
              )}
            {rivers.length > 0 && (
              <div className={css.rivers}>
                <span className={css.label}>Leagues:</span>
                {rivers.map(river => (
                  <Link route={`/${river.alias}/news`} key={river.alias}>
                    <a className={css.riverName}>{river.name}</a>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AuthorBanner.propTypes = {
  author: PropTypes.object.isRequired,
  rivers: PropTypes.array.isRequired,
};

AuthorBanner.displayName = 'AuthorBanner';

export default StyledComponent(AuthorBanner, [css]);
